<template>
    <div style="position:relative;">
        <SiteHeader action="infos"></SiteHeader>
        <div class="home-hero-wrapper">
            <div class="home-hero home-hero--panel home-hero--desktop" @click="nextStep()" style="cursor: pointer">
                <component :is="active_component"
                           :key="`component-${currentStepName}`"
                           @hook:beforeCreate="componentBeforeCreate"
                           @hook:created="componentCreated"
                           @hook:mounted="componentMounted"
                ></component>
                <HomeHeroDesktop></HomeHeroDesktop>
            </div>
        </div>
        <div class="home-hero home-hero--mobile" @click="nextStep()" style="cursor: pointer">
            <HomeHeroMobile>
                <component :is="active_component"
                           :key="`component-${currentStepName}`"
                           @hook:beforeCreate="componentBeforeCreate"
                           @hook:created="componentCreated"
                           @hook:mounted="componentMounted"
                ></component>
            </HomeHeroMobile>
        </div>
        <div class="home-content-wrapper">
            <HomeServiceSection :box="box"></HomeServiceSection>
            <hr class="line-break">
            <HomeAvantageSection></HomeAvantageSection>
            <HomeAboutUs></HomeAboutUs>
        </div>
        <HomeQuestion v-if="utm_source=='facebook'"></HomeQuestion>
        <SiteFooter></SiteFooter>
    </div>
</template>
<!--        <b-button class="button is-primary next-button next-button&#45;&#45;sticky" @click="nextStep()">Ontvang mijn pakket voor €2</b-button>-->

<script>
import steps_flux_mixin from "../_commons/nl/mixins/steps_flux_mixin";
import mixin from "../../components/form/steps/travel_step_mixin";
import AOS from 'aos';
import HomeHeroDesktop from "./home/HomeHeroDesktop";
import HomeHeroMobile from "./home/HomeHeroMobile";
import HomeTrust from "../_commons/nl/home/HomeTrust";
import HomeService from "../_commons/nl/home/HomeService";
import HomePack from "../_commons/nl/home/HomePack";
import HomeQuestion from "../_commons/nl/home/NewHomeQuestion/HomeQuestion";

import SiteHeader from "./SiteHeader.vue";
import SiteFooter from "../_commons/nl/newComponents/SiteFooter";

import InfosModal from "../_commons/nl/modals/InfosModal";
import {sync} from "vuex-pathify";
import HomeServiceSection from "./home/HomeServiceSection";
import HomeAvantageSection from "./home/HomeAvantageSection";
import image_mixin from '../../views/_commons/fr/mixins/image_mixin'
import HomeAboutUs from "./home/HomeAboutUs.vue";


export default {
    components: {
        HomeAboutUs,
        HomeServiceSection, HomeAvantageSection,HomeHeroDesktop, HomeHeroMobile, HomePack, HomeService, HomeTrust, HomeQuestion, SiteHeader, SiteFooter, InfosModal
    },
    mixins: [steps_flux_mixin,mixin,image_mixin],
    computed:{
        show_infos_modal: sync('func_data/show_infos_modal'),
        modal_active_tab: sync('func_data/modal_active_tab'),
        utm_source: sync('func_data/utm_source'),
    },
    mounted() {
        AOS.init();
    }
}
</script>

<style scoped>

</style>
